



























































import { defineComponent } from '@vue/composition-api';

import AppAccordionPanel from '@berlin-front/common/components/elements/AppAccordionPanel';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppText from '@berlin-front/common/components/elements/AppText';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppLink from '@berlin-front/common/components/elements/AppLink';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';

import { useContext } from '@berlin-front/common/composables/context';

import { useRouter } from '@berlin-front/common/composables/useRouter';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { ModalBridgeContext } from '@services/ModalBridgeContext';
import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { ROUTE_NAME } from '@/router/route-name';

export default defineComponent({
  name: 'AuthHelpView',
  components: {
    AppAccordionPanel,
    ModalHeader,
    AppCard,
    AppRow,
    AppLink,
    AppText,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const bridge = useContext(ModalBridgeContext);

    const router = useRouter();

    const myPageRemindUrl = process.env.VUE_APP_ATONE_PASSWORD_REMIND_URL;
    const myPageChangeMailUrl = process.env.VUE_APP_ATONE_CHANGE_MAIL;
    const myPageChangePhoneNumberUrl = process.env.VUE_APP_ATONE_CHANGE_PHONE_NUMBER;

    const atoneLoginClick = () => {
      if (router.currentRoute.name === ROUTE_NAME.ATONE_LITE_AUTH_ATONE_MEMBER_LOGIN) {
        bridge.hideHelp();
      } else {
        void router.replace({ name: ROUTE_NAME.ATONE_LITE_AUTH_ATONE_MEMBER_LOGIN });
      }
    };

    const npLoginClick = () => {
      if (router.currentRoute.name === ROUTE_NAME.ATONE_LITE_AUTH_NP_MEMBER) {
        bridge.hideHelp();
      } else {
        void router.replace({ name: ROUTE_NAME.ATONE_LITE_AUTH_NP_MEMBER });
      }
    };

    const guestLoginClick = () => {
      if (router.currentRoute.name === ROUTE_NAME.ATONE_LITE_AUTH_GUEST_LOGIN) {
        bridge.hideHelp();
      } else {
        void router.replace({ name: ROUTE_NAME.ATONE_LITE_AUTH_GUEST_LOGIN });
      }
    };

    // このページから離れるとき、isShowHelpを非表示にする。
    router.afterEach(() => {
      bridge.hideHelp();
    });

    return {
      // 関数
      myPageRemindUrl,
      myPageChangeMailUrl,
      myPageChangePhoneNumberUrl,
      atoneLoginClick,
      npLoginClick,
      guestLoginClick,
      bridge,

      // コンテキスト

      // 定数
      HEADER_TYPE,
      TEXT_WEIGHT,
      ROUTE_NAME,
    };
  },
});
